import { Component, OnInit } from '@angular/core';
import { WelcomeService } from './welcome.service';
import { MatSnackBar } from '@angular/material';
import { TranslationService } from 'angular-l10n';
import * as $ from 'jquery';


@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.scss','bootstrap.min.css','nucleo-icons.css','paper-kit.css']
})
export class WelcomeComponent implements OnInit {

  name : string = ''
  email : string = ''
  message: string = ''
  public number1 = 666;

  public gasto: any;
  public estimado: any;
  public show: any = false;
  public boton: any = "Calcular";
  public AhorroTotal : any = 0;
  public accounts : any = 0;
  public GastoAnalizado : any = 0;
  public NoCuentasAnalizadas : any = 0;
  public loquesea:any;


  constructor(private service: WelcomeService,private translationService: TranslationService,public snackBar: MatSnackBar) {
    
    this.service.savings().subscribe((response:any) =>{
      this.AhorroTotal = response.savings;
      console.log(this.AhorroTotal);
      this.AhorroTotal = this.numberWithCommas(this.AhorroTotal)

      $.fn.jQuerySimpleCounter = function( options ) {
        var settings = $.extend({
            start:  0,
            end:    100,
            easing: 'swing',
            duration: 400,
            complete: ''
        }, options );
  
        var thisElement = $(this);
  
        $({count: settings.start}).animate({count: settings.end}, {
        duration: settings.duration,
        easing: settings.easing,
        step: function() {
          var mathCount = Math.ceil(this.count);
          thisElement.text(mathCount);
        },
        complete: settings.complete
        });
      };



      this.service.analyzed().subscribe((response:any) =>{
        this.GastoAnalizado = response.analyzed;
        console.log(this.GastoAnalizado);
        this.GastoAnalizado = this.numberWithCommas(this.GastoAnalizado)

        $.fn.jQuerySimpleCounter = function( options ) {
          var settings = $.extend({
              start:  0,
              end:    100,
              easing: 'swing',
              duration: 400,
              complete: ''
          }, options );
    
          var thisElement = $(this);
    
          $({count: settings.start}).animate({count: settings.end}, {
          duration: settings.duration,
          easing: settings.easing,
          step: function() {
            var mathCount = Math.ceil(this.count);
            thisElement.text(mathCount);
          },
          complete: settings.complete
          });
        };

        this.service.lines().subscribe((response:any) =>{
          this.NoCuentasAnalizadas = response.quantity;
          console.log(this.NoCuentasAnalizadas);
          this.NoCuentasAnalizadas = this.numberWithCommas(this.NoCuentasAnalizadas)

          $.fn.jQuerySimpleCounter = function( options ) {
            var settings = $.extend({
                start:  0,
                end:    100,
                easing: 'swing',
                duration: 400,
                complete: ''
            }, options );
      
            var thisElement = $(this);
      
            $({count: settings.start}).animate({count: settings.end}, {
            duration: settings.duration,
            easing: settings.easing,
            step: function() {
              var mathCount = Math.ceil(this.count);
              thisElement.text(mathCount);
            },
            complete: settings.complete
            });
          };

          this.service.accounts().subscribe((response:any)=>{
            this.accounts = response.accounts;
            console.log(response.accounts)
            $.fn.jQuerySimpleCounter = function( options ) {
              var settings = $.extend({
                  start:  0,
                  end:    100,
                  easing: 'swing',
                  duration: 400,
                  complete: ''
              }, options );
        
              var thisElement = $(this);
        
              $({count: settings.start}).animate({count: settings.end}, {
              duration: settings.duration,
              easing: settings.easing,
              step: function() {
                var mathCount = Math.ceil(this.count);
                thisElement.text(mathCount);
              },
              complete: settings.complete
              });
            };

          });

        });
 
      });
   
    });
    $.fn.jQuerySimpleCounter = function( options ) {
      var settings = $.extend({
          start:  0,
          end:    100,
          easing: 'swing',
          duration: 400,
          complete: ''
      }, options );

      var thisElement = $(this);

      $({count: settings.start}).animate({count: settings.end}, {
      duration: settings.duration,
      easing: settings.easing,
      step: function() {
        var mathCount = Math.ceil(this.count);
        thisElement.text(mathCount);
      },
      complete: settings.complete
      });
    };
    $('#number1').jQuerySimpleCounter({end: this.AhorroTotal,duration: 2500});
    $('#number2').jQuerySimpleCounter({end: this.accounts,duration: 3000});
    $('#number3').jQuerySimpleCounter({end: this.GastoAnalizado,duration: 3500});
    $('#number4').jQuerySimpleCounter({end: this.NoCuentasAnalizadas,duration: 4000}); 
  }

  ngOnInit() {

    $.fn.jQuerySimpleCounter = function( options ) {
      var settings = $.extend({
          start:  0,
          end:    100,
          easing: 'swing',
          duration: 400,
          complete: ''
      }, options );

      var thisElement = $(this);

      $({count: settings.start}).animate({count: settings.end}, {
      duration: settings.duration,
      easing: settings.easing,
      step: function() {
        var mathCount = Math.ceil(this.count);
        thisElement.text(mathCount);
      },
      complete: settings.complete
      });
    };
    $('#number1').jQuerySimpleCounter({end: this.AhorroTotal,duration: 2500});
    $('#number2').jQuerySimpleCounter({end: this.accounts,duration: 3000});
    $('#number3').jQuerySimpleCounter({end: this.GastoAnalizado,duration: 3500});
    $('#number4').jQuerySimpleCounter({end: this.NoCuentasAnalizadas,duration: 4000}); 
  }

  sendEmail(){

    const contact = {
      name: this.name,
      email: this.email,
      message: this.message
    };

    
    this.service.saveEmail(contact).subscribe((response: any) => {

      this.handleSuccess()
      this.email= ""
      this.name = ""
      this.message = ""
    });
    
  }

  handleSuccess() {
    const msg = this.translationService.translate('welcome.success');
    const snackBarRef = this.snackBar.open(msg, null, {
      duration: 4000,
    });
  }

  calculadora()
  {
    if (this.boton == "Calcular")
    {
      this.boton = "Volver";
    }
    else
    {
      this.boton = "Calcular";
    }
    this.show = !this.show;
    this.estimado = this.gasto * 0.02;
  }

  numberWithCommas(x) {
    var parts = x.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  }

}



// WEBPACK FOOTER //
// ./src/app/views/welcome/welcome.component.ts